export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="border-t border-gray-700 pt-8">
          <div className="text-xs text-gray-400 leading-relaxed space-y-4">
            <p>
              <span>By visiting this page, you agree to terms and conditions, Privacy Policy &amp; earnings disclaimer.</span>
            </p>
            <p>
              This site is not a part of the Facebook website or Facebook Inc. Additionally, This site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc.
            </p>
            <p>
              <span>DISCLAIMER: The sales figures stated on this landing page and discussed in the AI Creator Course program are our personal sales figures and in some cases the sales figures of previous or existing clients. Please understand these results are not typical. We're not implying you'll duplicate them (or do anything for that matter). The average person who buys "how to" information gets little to no results. We're using these references for example purposes only. Your results will vary and depend on many factors including but not limited to your background, experience, and work ethic. All business entails risk as well as massive and consistent effort and action. If you're not willing to accept that, please DO NOT PURCHASE THE AI CREATOR COURSE.</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}